export var VELT_SDK_VERSION = '4.5.8-beta.6';
export var VELT_SDK_INIT_EVENT = 'onVeltInit';
export var VELT_TAB_ID = 'veltTabId';
// integrity map for the Velt SDK
// Note: generate integrity hashes with: https://www.srihash.org/
export var INTEGRITY_MAP = {
    '4.5.8-beta.6': 'sha384-eJ1/uzsIQZMFb7ttfweHlrJZMfAD5E97A9RO5XQrtl6/ZhiF3evJAxEz+udK1y75',
};
